// 节点类型
import { markBlockIcon } from "../../svg";
export const ELEMENT_TYPE = "markblock";
export const MENU_KEY = "xhMarkBlockKey";
export const MENU_NAME = "插入标记";
export const MENU_ICON = markBlockIcon;
